"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Note;
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
const useStyles = (0, _styles.makeStyles)(theme => ({
  note: {
    borderRadius: 8,
    backgroundColor: theme.palette.neutral[200],
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2)
  }
}));
function Note(_ref) {
  let {
    children
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.note
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, children));
}